type ColoredCircleType = {
  isOrange: boolean;
  size?: number;
};

const ColoredCircle = ({ isOrange, size = 8 }: ColoredCircleType) => (
  <div
    style={{
      backgroundColor: isOrange ? "#E2772E" : "#22BE39",
      border: `1px solid ${isOrange ? "#E2772E" : "#22BE39"}`,
      width: size,
      height: size,
      borderRadius: "50%",
      MozBorderRadius: "50%",
      WebkitBorderRadius: "50%",
    }}
  />
);

export default ColoredCircle;
